import React, { useEffect } from 'react';
import { Button, Form, Input, Select, Space, Typography } from 'antd';
import { useI18n } from '../i18n';

const { Title, Text } = Typography;

export default function PersonalProfilePage({ currentUser, onSave, onCancel }) {
  const [form] = Form.useForm();
  const { t } = useI18n();

  useEffect(() => {
    if (!currentUser) return;

    form.setFieldsValue({
      firstName: currentUser.firstName || '',
      lastName: currentUser.lastName || '',
      phone: currentUser.phone || '',
      email: currentUser.email || '',
      preferredLanguage: currentUser.preferredLanguage || 'en',
    });
  }, [currentUser, form]);

  return (
    <div style={{ maxWidth: 720 }}>
      <div style={{ marginBottom: 24 }}>
        <Title level={2} style={{ marginBottom: 6 }}>{t('Personal Profile')}</Title>
        <Text type="secondary">{t('Update your personal details and preferred working language.')}</Text>
      </div>

      <Form
        form={form}
        layout="vertical"
        onFinish={onSave}
      >
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 16 }}>
          <Form.Item
            label={t('First Name')}
            name="firstName"
            rules={[{ required: true, message: t('Please enter first name') }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={t('Last Name')}
            name="lastName"
            rules={[{ required: true, message: t('Please enter last name') }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={t('Phone')}
            name="phone"
            rules={[{ required: true, message: t('Please enter phone number') }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={t('Email')}
            name="email"
            rules={[
              { required: true, message: t('Please enter email address') },
              { type: 'email', message: t('Please enter a valid email address') },
            ]}
          >
            <Input />
          </Form.Item>
        </div>

        <Form.Item
          label={t('Preferred Language')}
          name="preferredLanguage"
          rules={[{ required: true, message: t('Please select preferred language') }]}
        >
          <Select
            options={[
              { value: 'en', label: t('English') },
              { value: 'da', label: t('Danish') },
            ]}
          />
        </Form.Item>

        <Space style={{ marginTop: 8 }}>
          <Button type="primary" htmlType="submit">
            {t('Save Changes')}
          </Button>
          <Button onClick={onCancel}>
            {t('Close')}
          </Button>
        </Space>
      </Form>
    </div>
  );
}
